import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Close from "../../../assets/icons/Close.svg";
import Autocomplete from "@mui/material/Autocomplete";
import countries from "../../../utils/CountryCodeData";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import {
  updateUserMasterList,
  setIsOpenModelEditUserMaster,
} from "../../../redux/actions/mastersAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ContactEyeIcon from "../../../assets/icons/ContentEyeIcon.svg";
import OpenEyeIcon from "../../../assets/icons/OpenEyeIcon.svg";
import PhoneNumber from "libphonenumber-js";
import { placeholder } from "@babel/types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const EditSuperintendentMasterModel = (Props) => {
  const dispatch = useDispatch();
  const isSaveButtonLoading = useSelector(
    (state) => state?.user?.isSaveButtonLoading
  );
  const SuperintendentID = localStorage.getItem("SuperintendentID");
  const CompanyID = localStorage.getItem("companyID");

  const EditUserMasterModel = useSelector(
    (state) => state?.masters?.EditUserMasterModel
  );

  const vesselMasterData = useSelector(
    (state) => state?.masters?.vesselMasterData
  );
  const phoneNumber = new PhoneNumber(
    String(EditUserMasterModel?.EditRowDataModel?.phone)
  );
  const [CountryCodeValue, setCountryCodeValue] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChangeCountryCodeValue = (newValue) => {
    setCountryCodeValue(newValue?.phone);
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const [SuperintendentData, setSuperintendentData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    Password: "",
    CompanyPhoneNo: "",
    VesselName: "",
  });

  const defaultCountry = countries.find(
    (country) => country.code === phoneNumber?.country
  );
  useEffect(() => {
    setSuperintendentData({
      FirstName: EditUserMasterModel?.EditRowDataModel?.first_name,
      LastName: EditUserMasterModel?.EditRowDataModel?.last_name,
      Email: EditUserMasterModel?.EditRowDataModel?.email,
      Password: EditUserMasterModel?.EditRowDataModel?.password,
      CompanyPhoneNo: phoneNumber?.nationalNumber,
      VesselName: EditUserMasterModel?.EditRowDataModel?.vessel_id || "",
    });
    setCountryCodeValue(phoneNumber?.countryCallingCode);
  }, [EditUserMasterModel, vesselMasterData]);

  const handleChangeSuperintendentData = (e) => {
    const { name, value } = e.target;
    setSuperintendentData({ ...SuperintendentData, [name]: value });
  };

  const handleSaveSuperintendent = async (event) => {
    event.preventDefault();
    if (
      SuperintendentData?.FirstName !== "" &&
      SuperintendentData?.LastName !== "" &&
      SuperintendentData?.Email !== "" &&
      SuperintendentData?.Password !== "" &&
      // SuperintendentData?.VesselName !== "" &&
      CountryCodeValue !== undefined &&
      SuperintendentData?.CompanyPhoneNo !== ""
    ) {
      const emailPattern =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (emailPattern.test(SuperintendentData?.Email)) {
        dispatch(
          updateUserMasterList({
            first_name: SuperintendentData?.FirstName,
            last_name: SuperintendentData?.LastName,
            email: SuperintendentData?.Email,
            password: SuperintendentData?.Password,
            phone: "+" + CountryCodeValue + SuperintendentData?.CompanyPhoneNo,
            username:
              SuperintendentData?.FirstName?.toLowerCase() +
              "." +
              SuperintendentData?.LastName?.toLowerCase(),
            company_id: CompanyID,
            role_id: SuperintendentID,
            // vessel_id: SuperintendentData?.VesselName,
            id: EditUserMasterModel?.EditRowDataModel?.id,
          })
        );
      } else {
        toast.error("Please enter valid Email ID");
      }
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  countries.sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Modal
      open={EditUserMasterModel?.isOpenEditModel}
      onClose={() => {
        const payload = {
          isOpenEditModel: false,
          EditRowDataModel: [],
        };
        dispatch(setIsOpenModelEditUserMaster(payload));
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Edit Superintendent Master
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={() => {
                const payload = {
                  isOpenEditModel: false,
                  EditRowDataModel: [],
                };
                dispatch(setIsOpenModelEditUserMaster(payload));
              }}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="First Name"
                name="FirstName"
                value={SuperintendentData?.FirstName}
                onChange={handleChangeSuperintendentData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Last Name"
                name="LastName"
                value={SuperintendentData?.LastName}
                onChange={handleChangeSuperintendentData}
                sx={{
                  borderRadius: "10px",
                  width: "100%",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Email"
                name="Email"
                value={SuperintendentData?.Email}
                onChange={handleChangeSuperintendentData}
                sx={{
                  width: "100%",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                id="outlined-basic"
                variant="outlined"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="Password"
                value={SuperintendentData?.Password}
                onChange={handleChangeSuperintendentData}
                sx={{
                  width: "100%",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleShowPassword}>
                        <img
                          src={showPassword ? OpenEyeIcon : ContactEyeIcon}
                          alt="Eye Icon"
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  maxLength: 9,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <Autocomplete
                id="country-select-demo"
                sx={{ width: 300 }}
                options={countries}
                onChange={(event, newValue) =>
                  handleChangeCountryCodeValue(newValue)
                }
                autoHighlight
                defaultValue={defaultCountry}
                getOptionLabel={(option) => "+" + option.phone}
                filterOptions={(options, state) => {
                  // Filter based on option.label
                  return options.filter((option) =>
                    option.label
                      .toLowerCase()
                      .includes(state.inputValue.toLowerCase())
                  );
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                    key={option.label}
                  >
                    <img
                      loading="lazy"
                      width="20"
                      srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                      src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                      alt=""
                    />
                    {option.label}
                    {/* ({option.code}) +{option.phone} */}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      borderRadius: "10px",
                      backgroundColor: "#F3F6F9",
                      border: "none",
                      "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        border: "0px solid #F3F6F9",
                        borderRadius: "10px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        display: "none",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    placeholder="Select Country"
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password",
                    }}
                  />
                )}
              />

              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Company Phone No"
                type="number"
                name="CompanyPhoneNo"
                value={SuperintendentData?.CompanyPhoneNo}
                onChange={handleChangeSuperintendentData}
                sx={{
                  width: "70%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .MuiInputBase-input": {
                    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button":
                      {
                        "-webkit-appearance": "none",
                        margin: 0,
                      },
                    "-moz-appearance": "textfield",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <Select
                id="outlined-basic"
                variant="outlined"
                displayEmpty
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={GreyDownArrow}
                      alt="Custom Icon"
                      width="18"
                      height="24"
                    />
                  </Box>
                )}
                name="VesselName"
                value={SuperintendentData?.VesselName}
                onChange={handleChangeSuperintendentData}
                sx={{
                  width: "100%",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                MenuProps={{
                  sx: {
                    ".MuiList-root": {
                      maxHeight: "270px",
                      // width: "300px",
                      wordBreak: "break-word",
                    },
                    ".MuiMenuItem-root": {
                      overflowWrap: "break-word",
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Vessel Name
                </MenuItem>
                {vesselMasterData.map((item) => (
                  <MenuItem value={item?.id}>{item?.name}</MenuItem>
                ))}
              </Select>
            </Box> */}
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Button
              // variant="contained"
              sx={{
                fontSize: "15px",
                border: "1px solid #26875C",
                fontWeight: 600,
                width: "8rem",
                // backgroundColor: "#26875C",
                padding: "10px 5px 10px 5px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#26875C",
                // ":hover": {
                //   backgroundColor: "#26875C",
                // },
              }}
              onClick={() => {
                const payload = {
                  isOpenEditModel: false,
                  EditRowDataModel: [],
                };
                dispatch(setIsOpenModelEditUserMaster(payload));
              }}
            >
              Cancel
            </Button>

            <LoadingButton
              onClick={handleSaveSuperintendent}
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                width: "8rem",
                border: "1px solid #26875C",
                backgroundColor: "#26875C",
                padding: "10px 5px 10px 5px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#FFFFFF",
                ":hover": {
                  backgroundColor: "#26875C",
                },
              }}
              loading={isSaveButtonLoading}
            >
              Save
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditSuperintendentMasterModel;
